import type { IInvitableGroup } from "../../../api/admin";
import { PERMISSION_LEVEL_VIEW } from "../../../constants";

export function defaultContributorGroupId(
  groups: IInvitableGroup[],
  folderId: number
): number | undefined {
  const contributor = groups.find(
    (g) => g.folder_id === folderId && g.level === PERMISSION_LEVEL_VIEW
  );
  return contributor?.id;
}

export function dedupeGroupIdsByFolder(
  groupIds: number[],
  invitableGroups: IInvitableGroup[]
): number[] {
  const groupsById = new Map(invitableGroups.map((g) => [g.id, g]));
  const folderIdsSeen = new Set<number>();
  const deduped: number[] = [];
  for (let i = groupIds.length - 1; i >= 0; i--) {
    const group = groupsById.get(groupIds[i]);
    if (!group) continue;
    if (folderIdsSeen.has(group.folder_id)) continue;
    folderIdsSeen.add(group.folder_id);
    deduped.unshift(groupIds[i]);
  }
  return deduped;
}
